export default {
  showSegmentationSize: (state) => {
    return Boolean(state.segmentationGroups.groups && state.segmentationGroups.groups.length && state.segmentationSize)
  },
  segmentationSize: (state) => {
    if (state.evaluatedSegment) {
      return state.evaluatedSegment.clients_qty
    } else {
      return 0
    }
  },
  updatingSegmentsIds: (state) => state.updatingSegmentsIds,
  refreshedSegments: (state) => state.refreshedSegments,
  segmentationClientsCoordinates: (state) => state.segmentationClientsCoordinates,
  segmentationStatusCount: (state) => state.segmentationStatusCount,
  segmentationLoaderCounter: (state) => state.segmentationLoaderCounter,
  selectedSegmentationAnalyticsConfigurationsIds: (state) => state.segmentationAnalyticConfigurationsIds,
  segmentationLimiter: (state) => state.segmentationGroups.limiter,
  tagsList: (state) => state.tagsList,
  segmentationDeletedTag: (state) => state.deletedTag,
  segmentationUpdatedTag: (state) => state.updatedTag,
}
